import { render } from "./ViceStats.vue?vue&type=template&id=ad460376"
import script from "./ViceStats.vue?vue&type=script&lang=js"
export * from "./ViceStats.vue?vue&type=script&lang=js"

import "./ViceStats.vue?vue&type=style&index=0&id=ad460376&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__